export enum ConversionType {
    IntendedMicrositeRecipient = 1,
    VoucherHolderMicrositeRecipient = 2,
}
